import { sendCleverTapEvent } from './nativeSupport';

export const logAnalyticsEvent = (params: any, isMarketing = false): void => {
	params = { ...params, Product: 'AutoPayUPI' };
	const eventName = [params?.Product, params?.Screen, params?.Module, params?.Element, params?.Action]
		.filter((t) => t)
		.join('_');
	const eventParams = {
		event_source: 'front_end',
		marketing_event: isMarketing ? 'yes' : 'no',
		...params,
	};
	//CleverTap Events
	sendCleverTapEvent(eventName, eventParams);
	// eslint-disable-next-line no-console
	console.log('%c << 🤖 >> Event Sent ✅', 'color: white; font-weight: bold;', { eventName, eventParams });
};
